import { PersonModel } from "./PersonModel";
import { formatLocalDateTimeForApi } from "@/data/utils/trabalhoCorrecaoPatch";

export class InjectionActivityModel {
  constructor({
    id,
    opId,
    osId,
    machineId,
    quantityProduced,
    quantityRefugo,
    quantityBorra,
    quantityGalho,
    isPaused,
    startDateTime,
    endDateTime,
    serviceTypeId,
    team,

    isDropdownVisible,
  }) {
    this.id = id;
    this.opId = opId;
    this.osId = osId ?? null;
    this.machineId = machineId;
    this.quantityProduced = quantityProduced;
    this.quantityRefugo = quantityRefugo;
    this.quantityBorra = quantityBorra;
    this.quantityGalho = quantityGalho ?? 0;
    this.isPaused = isPaused;
    this.startDateTime = startDateTime;
    this.endDateTime = endDateTime;
    this.serviceTypeId = serviceTypeId;
    this.team = team;

    this.isDropdownVisible = isDropdownVisible ?? false;
  }

  static fromJson(json) {
    return new InjectionActivityModel({
      id: json.id,
      opId: json.op_cod ?? json.op_id ?? null,
      osId: json.os_id ?? null,
      machineId: json.maquina_id,
      quantityProduced: json.qtProduzida ?? 0,
      quantityRefugo: json.qtRefugo ?? 0,
      quantityBorra: json.qtBorra ?? 0,
      quantityGalho: json.qtGalho ?? 0,
      isPaused: json.pausado,
      startDateTime: new Date(json.dtInicio),
      endDateTime: json.dtFim != null ? new Date(json.dtFim) : null,
      serviceTypeId: json.servico_id,
      team: (json.colaboradores ?? []).map((ele) =>
        PersonModel.fromJson(ele)
      ),
    });
  }

  toRemote() {
    const equipe = (this.team ?? []).map((ele) =>
      typeof ele.minimalToRemote === "function"
        ? ele.minimalToRemote()
        : { colaborador_id: ele.id }
    );

    return {
      dtInicio: formatLocalDateTimeForApi(this.startDateTime),
      dtFim:
        this.endDateTime != null && this.endDateTime !== ""
          ? formatLocalDateTimeForApi(this.endDateTime)
          : null,
      servico_id: this.serviceTypeId,
      maquina_id: this.machineId,
      qtProduzida: this.quantityProduced,
      qtBorra: this.quantityBorra,
      qtRefugo: this.quantityRefugo,
      qtGalho: this.quantityGalho,
      equipe,
    };
  }
}
